module.exports = __webpack_public_path__ + "static/img/img_awards_6.f8bb473.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aboutUs/img_awards_6.png
// module id = saAs
// module chunks = 15